import React from 'react'
import PropTypes from 'prop-types'
import { array } from 'common/helpers'

import Box from 'components/_new/layout/Box/Box'
import Row from 'components/_new/layout/Row/Row'

import bottleImage from './images/bottle.svg'


const ProductsPerMonth = ({ count }) => (
  <Row justify="start">
    {
      array.range(1, count)
        .map((count, index) => (
          <Box key={count} ml={Boolean(index) && '8'}>
            <img src={bottleImage} alt="" />
          </Box>
        ))
    }
  </Row>
)

ProductsPerMonth.propTypes = {
  count: PropTypes.number,
}


export default ProductsPerMonth
